import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoading = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	id: "svg858",
	viewBox: "0 0 60 60",
	height: "60px",
	width: "60px",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { id: "defs862" }),
		/* @__PURE__ */ _jsx("title", {
			id: "title849",
			children: "D056DA86-4F40-4421-BCC3-9BA2DA570EE7"
		}),
		/* @__PURE__ */ _jsx("desc", {
			id: "desc851",
			children: "Created with sketchtool."
		}),
		/* @__PURE__ */ _jsx("g", {
			fillRule: "evenodd",
			fill: "none",
			strokeWidth: 1,
			stroke: "none",
			id: "Flusso-Full",
			children: /* @__PURE__ */ _jsx("g", {
				fillRule: "nonzero",
				fill: "#E1E1E1",
				transform: "translate(-570.000000, -421.000000)",
				id: "15_Loading",
				children: /* @__PURE__ */ _jsx("g", {
					transform: "translate(570.000000, 421.000000)",
					id: "Group-3",
					children: /* @__PURE__ */ _jsx("g", {
						id: "Group",
						children: /* @__PURE__ */ _jsx("path", {
							id: "Oval",
							d: "M30,60 C46.5685425,60 60,46.5685425 60,30 C60,13.4314575 46.5685425,0 30,0 C13.4314575,0 0,13.4314575 0,30 C0,46.5685425 13.4314575,60 30,60 Z M30,53 C17.2974508,53 7,42.7025492 7,30 C7,17.2974508 17.2974508,7 30,7 C42.7025492,7 53,17.2974508 53,30 C53,42.7025492 42.7025492,53 30,53 Z"
						})
					})
				})
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "translate(36.850576,28.199447)",
			style: {
				fill: "none",
				fillRule: "evenodd",
				stroke: "none",
				strokeWidth: 1
			},
			id: "Flusso-Full-0",
			children: /* @__PURE__ */ _jsx("g", {
				style: {
					fill: "#5c5c5c",
					fillRule: "nonzero"
				},
				id: "15_Loading-0",
				transform: "translate(-607,-449)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group-3-1",
					transform: "translate(570,421)",
					children: /* @__PURE__ */ _jsx("g", {
						id: "Group-35",
						children: /* @__PURE__ */ _jsx("path", {
							d: "m 41.904567,57.531921 c 0.414605,-0.171742 0.674026,-0.283209 0.778264,-0.334402 6.845064,-3.361738 13.838936,-9.568389 16.648727,-20.678964 0.413594,-1.635451 0.647941,-3.188511 0.703039,-4.659182 0.06203,-1.655694 -1.229887,-3.048184 -2.885581,-3.110215 -0.03742,-0.0014 -0.07487,-0.0021 -0.112316,-0.0021 h -1.068542 c -1.58706,2e-6 -2.899543,1.236084 -2.994611,2.820294 -0.25265,4.210142 -1.481194,7.887061 -3.685632,11.030757 -1.88453,2.687485 -4.613623,6.151645 -9.4278,8.014639 -0.130141,0.05036 -0.373473,0.158841 -0.729996,0.325437 -1.37005,0.640205 -2.049416,2.20005 -1.584997,3.639222 l 0.356323,1.104199 c 0.508819,1.576797 2.19955,2.442553 3.776344,1.933724 0.07668,-0.02475 0.152336,-0.05257 0.226778,-0.08341 z",
							id: "Oval-Copy"
						})
					})
				})
			})
		})
	]
});
export default SvgLoading;
